module.exports = __webpack_public_path__ + "static/img/honor16.b583393.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/honor/honor16.png
// module id = pQZV
// module chunks = 0